import { FLYBITS } from '../constants';
import { AUTHENTICATION_STATE, ISession } from '../types/authentication';
import axios from '../utils/axios';

export const ANONYMOUS_SESSION: ISession = {
    id: '',
    state: AUTHENTICATION_STATE.LOGIN_PROMPTED,
}

export const login = async (email: string, password: string): Promise<string| undefined> => {
    let session;
    try {
        const response = (await axios.post(FLYBITS.FLYBITS_HOST + '/sso/auth/authenticate', {
            email,
            password
        }));
        if (200 === response.status) {
            session = response.headers['x-authorization'];
        }
    } catch (e) {/* tslint:disable:no-empty */}
    return session;
}


export const loadSession = (): ISession => (ANONYMOUS_SESSION)



// WEBPACK FOOTER //
// ./src/services/authentication.ts